import * as React from 'react';
import connect from 'react-redux/es/connect/connect';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Menu } from '../../components/menu/Menu';
import Toast from '../../components/Toasts/Toast';
import ClienteCrud from '../clientes/ClienteCrud';
import ConfiguracaoEdit from '../configuracao/ConfiguracaoEdit';
import Dashboardindex from '../dashboard/DashboardIndex';
import ImportarPedidoCrud from '../importarPedidos/ImportarPedidoCrud';
import MapaProdutosCrud from '../mapaProdutos/MapaProdutosCrud';
import NotasCrud from '../notas/NotasCrud';
import PedidoDevolucaoCrud from '../pedidoDevolucao/PedidoDevolucaoCrud';
import PedidoEmMapaCrud from '../pedidoEmMapa/PedidoEmMapaCrud';
import PedidosCrud from '../pedidos/PedidosCrud';
import PontoAtendimentoCrud from '../pontoAtendimento/PontoAtendimentoCrud';
import ProdutoBloqueadoCrud from '../produtoBloqueado/ProdutoBloqueadoCrud';
import Topo from '../Topo/Topo';
import UsuarioCrud from '../usuarios/UsuarioCrud';
type Props = {};
type State = {
  isModalVisible: boolean,
};
class Main extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isModalVisible: false,
    };
    this._toggleModal = this._toggleModal.bind(this);
  }

  _toggleModal = () => {
    this.setState({ isModalVisible: !this.state.isModalVisible });
  };
  render() {
    return (
      <div>
        <Menu />
        <Topo />
        <Toast />
        <div className="content-wrap d-flex justify-content-center flex-column flex-sm-row">
          <Switch>
            <Route path="/cliente" component={ClienteCrud} />
            <Route path="/dashboard" component={Dashboardindex} />

            <Route path="/usuario" component={UsuarioCrud} />
            <Route path="/configuracoes/view/" component={ConfiguracaoEdit} />
            <Route path="/notas" component={NotasCrud} />

            <Route path="/pontoAtendimento" component={PontoAtendimentoCrud} />
            <Route path="/mapaProdutos" component={MapaProdutosCrud} />
            <Route path="/produtoBloqueado" component={ProdutoBloqueadoCrud} />
            <Route path="/pedidoDevolucao" component={PedidoDevolucaoCrud} />
            <Route path="/pedidoEmMapa" component={PedidoEmMapaCrud} />
            <Route path="/importarPedido" component={ImportarPedidoCrud} />

            <Route path="/pedidos" component={PedidosCrud} />
          </Switch>
        </div>
        <footer>
          <div className="mt-auto rodape">
            {new Date().getFullYear()} © biotechlogistica. -{' '}
            <a
              href="http://www.biotechlogistica.com.br"
              rel="noopener noreferrer"
              target="_blank"
            >
              Code 4 Sistemas
            </a>
          </div>
        </footer>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { user, permissions } = state.authentication;

  return {
    user,
    permissions,
  };
}

export default withRouter(connect(mapStateToProps)(Main));
